import * as React from 'react';
import { lazyMountAndShowFullOptions } from 'owa-options-view';

export default function onCustomizeActions() {
    return (event: React.KeyboardEvent<HTMLElement> | React.MouseEvent<HTMLElement>) => {
        event.stopPropagation();
        lazyMountAndShowFullOptions.importAndExecute(
            'mail',
            'surfaceActions',
            'readSurfaceActions'
        );
    };
}
